var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgGroup(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 70,
    height: 86,
    viewBox: "0 0 70 86",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fillRule: "nonzero",
    fill: "none"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "#F4B000"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M45 29.967v29.378H31.59c-3.684 0-5.622 2.516-5.82 2.655h-6.54c-.2-.141-2.11-2.655-5.82-2.655H0V27.313h2.637V56.69H13.42c4.12 0 6.414 2.34 6.985 2.654h4.188c.57-.314 2.865-2.654 6.985-2.654h10.784V29.967H45z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.75 55.438a12.624 12.624 0 0 0-5.064-1.05H5.625V22.624h2.609v26.498h3.913c3.555 0 6.463 2.808 6.603 6.315zM31.26 24.5c-2.782 0-5.46.734-7.823 2.138.062.601.093 1.212.093 1.831v27.906c.176-.129.377-.271.606-.423 4.054-2.724 6.848-2.168 15.239-2.168V24.5H31.26z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.625 55.438c0-5.093-4.053-9.236-9.034-9.236h-1.278V17c6.39 0 10.312 5.327 10.312 11.874v26.564z"
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#EF84C2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M31 69.378v15.244h-7.152c-1.965 0-2.998 1.306-3.104 1.378h-3.488c-.107-.073-1.126-1.378-3.104-1.378H7V68h1.406v15.245h5.752c2.197 0 3.42 1.214 3.725 1.377h2.234c.304-.162 1.528-1.377 3.725-1.377h5.752V69.378H31z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17 83a6.573 6.573 0 0 0-2.7-.576H10V65h1.391v14.536h2.087c1.896 0 3.447 1.54 3.522 3.464zM23.417 66c-1.57 0-3.083.392-4.417 1.14.034.32.052.647.052.977V83c.1-.069.213-.145.342-.225 2.29-1.453 3.868-1.157 8.606-1.157V66h-4.583z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18 83c0-2.782-2.358-5.046-5.256-5.046H12V62c3.719 0 6 2.91 6 6.487V83z"
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#6FA0EC"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M70 8.913v21.174h-9.536c-2.62 0-3.998 1.813-4.138 1.913h-4.652c-.142-.102-1.5-1.913-4.138-1.913H38V7h1.875v21.173h7.669c2.93 0 4.56 1.687 4.967 1.914h2.978c.406-.227 2.037-1.914 4.967-1.914h7.669V8.913H70z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52 28a10.34 10.34 0 0 0-3.858-.736H42V5h1.988v18.574h2.981c2.709 0 4.924 1.968 5.031 4.426zM59.89 6c-2.095 0-4.112.507-5.89 1.476.046.415.07.836.07 1.264V28c.132-.089.283-.187.456-.292 3.053-1.88 5.156-1.496 11.474-1.496V6h-6.11z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53 28c0-3.71-2.75-6.728-6.132-6.728H46V0c4.338 0 7 3.88 7 8.65V28z"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroup);
export default __webpack_public_path__ + "static/media/group.84d8529bf43f857bb855036e2f9d9699.svg";
export { ForwardRef as ReactComponent };